import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";


@Injectable()
export class RouteConfig {
    Url(url: string): string {
        return environment.apiURL.toString() + url;
    }
}